import { ControlsOf } from '@elio/shared/models';
import { User } from './user.model';

export interface AuthenticationRequest {
  login: string;
  password: string;
  rememberMe: boolean;
}

export interface AuthenticationResponse {
  jwtAccessToken: string;
  user: User;
}

export interface RefreshTokenResponse {
  jwtAccessToken: string;
}

export type UserPermission =
  | 'CHANGE_MATERIAL'
  | 'CHANGE_PASSWORD_FAMILIES'
  | 'CHANGE_PASSWORD_PROS'
  | 'EDIT_BOX_LIGHT'
  | 'EDIT_SUPERVISOR'
  | 'MANAGE_CATERING'
  | 'MANAGE_COMMON_CONTENT'
  | 'MANAGE_CONTENT'
  | 'MANAGE_FACILITY_PROFILE'
  | 'MANAGE_FAMILIES'
  | 'MANAGE_HEADQUARTERS'
  | 'MANAGE_MONITORING'
  | 'MANAGE_OFFERS_HEADQUARTER'
  | 'MANAGE_OFFERS'
  | 'MANAGE_PLANNING'
  | 'MANAGE_PROS_HEADQUARTER'
  | 'MANAGE_PROS'
  | 'MANAGE_PUBLICATIONS_HEADQUARTER'
  | 'MANAGE_PUBLICATIONS'
  | 'MANAGE_RESIDENTS'
  | 'MANAGE_ROOMS'
  | 'MANAGE_SERVICE_NOTES'
  | 'MANAGE_SERVICES'
  | 'MANAGE_SOFTWARE'
  | 'MANAGE_SUPPORT'
  | 'MANAGE_TEAMS'
  | 'MANAGE_TV'
  | 'RECEIVE_ROOM'
  | 'RUN_TASK'
  | 'VIEW_COMMON_CONTENT'
  | 'VIEW_CONTENT'
  | 'VIEW_EMAIL'
  | 'VIEW_FAMILIES'
  | 'VIEW_HEADQUARTERS'
  | 'VIEW_MONITORING'
  | 'VIEW_MONITORING_HEADQUARTER'
  | 'VIEW_NOTIFICATIONS'
  | 'VIEW_OFFERS_HEADQUARTER'
  | 'VIEW_OFFERS'
  | 'VIEW_PJ'
  | 'VIEW_PLANNING'
  | 'VIEW_PROS_HEADQUARTER'
  | 'VIEW_ADMIN_HEADQUARTER'
  | 'VIEW_PROS'
  | 'VIEW_PUBLICATIONS_HEADQUARTER'
  | 'VIEW_PUBLICATIONS'
  | 'VIEW_RESIDENTS'
  | 'VIEW_ROOMS'
  | 'VIEW_SERVICE_NOTES'
  | 'VIEW_SERVICES'
  | 'VIEW_SOFTWARE'
  | 'VIEW_TEAMS'
  | 'VIEW_TV_RADIO'
  | 'VIEW_TV'
  | 'VIEW_WIFI'
  | 'WRITE_EMAIL_TO_PRO'
  | 'WRITE_EMAIL'
  | 'MANAGE_CUSTOMIZED_LAYOUT';

export interface Permission {
  name: UserPermission;
}

export interface ForgottenPasswordFormValue {
  email: string;
}

export type ForgottenPasswordForm = ControlsOf<ForgottenPasswordFormValue>;

export interface DefinePasswordFormValue {
  password: string;
  confirmPassword: string;
}

export type DefinePasswordForm = ControlsOf<DefinePasswordFormValue>;

export interface LoginFormValue {
  login: string;
  password: string;
  rememberMe: boolean;
}

export type LoginForm = ControlsOf<LoginFormValue>;
